import { render, staticRenderFns } from "./HomeworksMobile.vue?vue&type=template&id=c0c81d72&scoped=true&"
import script from "./HomeworksMobile.vue?vue&type=script&lang=js&"
export * from "./HomeworksMobile.vue?vue&type=script&lang=js&"
import style0 from "./HomeworksMobile.vue?vue&type=style&index=0&id=c0c81d72&prod&lang=scss&scoped=true&"
import style1 from "./HomeworksMobile.vue?vue&type=style&index=1&id=c0c81d72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c81d72",
  null
  
)

export default component.exports